export const awaitAnimationFrame = () => {
	return new Promise((resolve) => {
		requestAnimationFrame(resolve);
	});
};
